import '../pages/Survey.css';

/**
 * Barra de progreso unificada para flujos por pasos (jornada, observador, diagnóstico inicial).
 * @param {number} step — Paso actual (1-based)
 * @param {number} totalSteps — Total de pasos
 * @param {string} [label] — Etiqueta opcional (p. ej. "Pregunta" en lugar de "Paso")
 */
export default function QuizStepProgress({ step, totalSteps, label = 'Paso' }) {
    const total = Math.max(1, Number(totalSteps) || 1);
    const current = Math.min(Math.max(1, Number(step) || 1), total);
    const pct = (current / total) * 100;

    return (
        <div className="quiz-progress-container" aria-label={`${label} ${current} de ${total}`}>
            <div className="quiz-progress-meta">
                <span>
                    {label} {current} de {total}
                </span>
                <span>{Math.round(pct)}%</span>
            </div>
            <div className="quiz-progress-track">
                <div className="quiz-progress-fill" style={{ width: `${pct}%` }} />
            </div>
        </div>
    );
}
